import { render, staticRenderFns } from "./HistoricoDiagnostico.vue?vue&type=template&id=7e4c8bd4"
import script from "./HistoricoDiagnostico.vue?vue&type=script&lang=js"
export * from "./HistoricoDiagnostico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports